import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from 'material-ui/Typography';
import Title from '../common/Title';
import { KEYMAN_CALL_CALLTREE_ACCOUNT_ID } from "../../../../../constants/Constants";

const styles = () => ({
  root: {
    background: '#F4F6F9',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100%',
    padding: '25px 25px 20px 25px',
    boxSizing: 'border-box',
  },

  empty: {
    padding: '12px',
    fontSize: '13px',
  },

  memoTile: {
    color: '#71737B',
    fontSize: '13px',
  },

  tip: {
    width: 0,
    height: 0,
    borderLeft: '25px solid transparent',
    borderRight: '25px solid transparent',
    borderTop: '15px solid #F4F6F9',
    position: 'absolute',
    left: 'calc(50% - 10px)',
  },
});

class KeymanCallMemos extends React.Component {

  getClientName = (follow_call_timeline_status) => {
    if (!follow_call_timeline_status.user) {
      return '';
    }

    if (follow_call_timeline_status.user.id === KEYMAN_CALL_CALLTREE_ACCOUNT_ID) {
      return 'KC';
    }

    if (!follow_call_timeline_status.user.user_payment) {
      return follow_call_timeline_status.user.name;
    }

    return follow_call_timeline_status.user.user_payment.bill_company;
  }

  render () {
    const { classes, item } = this.props;

    if (!item || !item.follow_call_timeline_statuses || item.follow_call_timeline_statuses.length === 0) {
      return null;
    }

    return (
      <div>
        <div className={classes.root}>
          <Title title="コールメモ" color="light" style={{ marginTop: '0px'}} />
          {(() => {
            return item.follow_call_timeline_statuses.map((follow_call_timeline_status, i) => (
              <div key={i}>
                <div className={classes.memoTile}>{follow_call_timeline_status.created_at} 【{follow_call_timeline_status.title}】  {this.getClientName(follow_call_timeline_status)}</div>
                <Typography variant="body2" key={i} style={{ color: 'inherit', marginTop: '5px'}}>
                  {follow_call_timeline_status.desc}
                </Typography>
                <div></div>
              </div>
            ))
          })()}
        </div>
        <div className={classes.tip} />
      </div>
    );
  }
}

KeymanCallMemos.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object,
}

PropTypes.defaultValue = {}

export default withStyles(styles)(KeymanCallMemos);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/ExecDetailItemDialog/sections/KeymanCallMemos.jsx